import type { Values, Rule, RuleMap } from './type';
import _ from 'lodash';
import { RuleEntity, PageRule } from './type';

export enum ResultType {
  /** 可见性规则 */
  Usability = 'usability',
  /** 强制性规则 */
  Mandatory = 'mandatory',
  /** 可编辑性规则 */
  Editable = 'editable',
  /** 计算公式 */
  Calculate = 'calculate',
}

export interface Value {
  // 如果field不存在，则此条数据代表针对模型的配置
  [ResultType.Usability]?: Array<{ modelCode: string; field?: string[] }>;
  [ResultType.Mandatory]?: Array<{ modelCode: string; field: string[] }>;
  [ResultType.Editable]?: Array<{ modelCode: string; field: string[] }>;
  [ResultType.Calculate]?: Array<{ modelCode: string; field: string; expression: string }>;
  bizComponent: { [fieldCode: string]: any };
}
export interface ValueNew {
  /** 规则控制的逻辑实体列表 */
  entitys: RuleEntity[];
}

/**
 * 将规则解析为更加可读的类型
 */
export function getPageRules(rules: Rule[]): PageRule[] {
  const rulesMap: RuleMap = {};
  const pageRules: PageRule[] = [];
  rules.forEach((rule) => {
    if (rule.RULES) {
      const pageRule: PageRule = {
        RULES: rule.RULES,
        entitys: [],
        trigger: rule.trigger,
        triggerConfig: rule.triggerConfig,
        message: rule.message,
      };
      pageRules.push(pageRule);
      if (rule.TODOOPTIONS?.entitys) {
        pageRule.entitys = [...pageRule.entitys!, ...rule.TODOOPTIONS.entitys];
      } else {
        const ruleByOldParse = parseValue(rule.TODOOPTIONS);
        if (ruleByOldParse.entitys) {
          pageRule.entitys = [...pageRule.entitys!, ...ruleByOldParse.entitys];
        }
      }

      // 解析页面配置中的规则
      if (rule?.TODOOPTIONS?.pageEvent?.isMakeBtn) {
        Object.keys(rule?.TODOOPTIONS?.pageEvent?.btnConfig || {}).forEach((btnConfigType) => {
          Object.keys(_.get(rule, `TODOOPTIONS.pageEvent.btnConfig.${btnConfigType}`, {})).forEach((key: string) => {
            rulesMap[key] = rulesMap[key] || {};
            if (_.get(rule, ['TODOOPTIONS', 'pageEvent', 'btnConfig', btnConfigType, key])) {
              rulesMap[key].visible = rule.RULES;
            } else {
              rulesMap[key].hidden = rule.RULES;
            }
          });
        });
      }
      // 解析模型中的是否可编辑
      (rule?.TODOOPTIONS?.editable || []).forEach((editable) => {
        editable.field.forEach(f => {
          const key = `${editable.modelCode}.${f}`;
          rulesMap[key] = rulesMap[key] || {};
          rulesMap[key].disabled = rule.RULES;
        });
      });
      // 解析模型中的是否可编辑
      (rule?.TODOOPTIONS?.mandatory || []).forEach((mandatory) => {
        mandatory.field.forEach(f => {
          const key = `${mandatory.modelCode}.${f}`;
          rulesMap[key] = rulesMap[key] || {};
          rulesMap[key].required = rule.RULES;
        });
      });
    }
  });
  console.log('pageRule', pageRules);
  return pageRules;
}

/** 改动数据结构，将老结构转化为新结构 */
export function parseValue(value?: Value): ValueNew {
  if (!value) {
    return { entitys: [] };
  }
  if (value.entitys) {
    return value;
  }

  const newValue: ValueNew = { entitys: [] };
  const set = (entityCode: string, attrCode: string, v: any) => {
    let entity = newValue.entitys.find(e => e.code === entityCode);
    if (!entity) {
      entity = { code: entityCode, attrs: [] };
      newValue.entitys.push(entity);
    }
    let attr = entity.attrs.find(a => a.code === attrCode);
    if (!attr) {
      attr = { code: attrCode };
      entity.attrs.push(attr);
    }
    Object.assign(attr, v);
  };
  Object.keys(value).forEach((key: string) => {
    if (key === ResultType.Usability) {
      value[key]!.forEach((model) => {
        model.field?.forEach((f) => set(model.modelCode, f, { visible: false }));
      });
    }
    if (key === ResultType.Mandatory) {
      value[key]!.forEach((model) => {
        model.field?.forEach((f) => set(model.modelCode, f, { required: true }));
      });
    }
    if (key === ResultType.Editable) {
      value[key]!.forEach((model) => {
        model.field?.forEach((f) => set(model.modelCode, f, { disabled: true }));
      });
    }
    if (key === ResultType.Calculate) {
      value[key]!.forEach((model) => {
        set(model.modelCode, model.field, { calculate: model.expression });
      });
    }
    if (key === 'bizComponent') {
      (Object.keys(value[key]))!.forEach((modelCode) => {
        Object.keys(value[key][modelCode]).forEach(fieldCode => {
          set(modelCode, fieldCode, { bizComponent: value[key][modelCode][fieldCode] });
        });
      });
    }
  });
  return newValue;
}
